<template>
  <div class="app-shell">
    <TopHeader />
    <div class="workspace">
      <ConversationList />
      <ChatPanel />
      <DocumentPanel />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import TopHeader from "@/components/TopHeader.vue";
import ConversationList from "@/components/ConversationList.vue";
import ChatPanel from "@/components/ChatPanel.vue";
import DocumentPanel from "@/components/DocumentPanel.vue";
import { useAuthStore } from "@/stores/auth";
import { fetchMe } from "@/api/auth";

const auth = useAuthStore();

onMounted(async () => {
  if (!auth.me && auth.token) {
    try {
      auth.setMe(await fetchMe());
    } catch {
      auth.logout();
    }
  }
});
</script>

<style scoped>
.app-shell {
  display: grid;
  grid-template-rows: 52px 1fr;
  height: 100vh;
  overflow: hidden;
}
.workspace {
  display: grid;
  grid-template-columns: 300px 1fr 460px;
  overflow: hidden;
  background: var(--paper);
  min-height: 0;
}
.workspace > * {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}
@media (max-width: 1400px) {
  .workspace {
    grid-template-columns: 260px 1fr 420px;
  }
}
@media (max-width: 1200px) {
  .workspace {
    grid-template-columns: 240px 1fr 380px;
  }
}
</style>
